import { render, staticRenderFns } from "./purchaseDiscount.vue?vue&type=template&id=3df00c0c"
import script from "./purchaseDiscount.vue?vue&type=script&lang=js"
export * from "./purchaseDiscount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports